<template>
  <el-container>
    <el-header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{ $t('monitoringCenter.home') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('zi-yuan-zhong-xin') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('ge-ren-zhuang-guan-li') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main>
      <el-row>
        <el-col :span="24">
          <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
            <el-form size="mini" class="search_form">
              <el-row>
                <el-col :span="2" style="float: right">
                  <el-button size="medium" @click="show3 = !show3" type="primary" class="el-btn">
                    {{ $t('sou-suo') }}<i class="el-icon-caret-bottom el-icon--right"></i>
                  </el-button>
                </el-col>
                <el-col :span="3" style="float: right">
                  <el-button size="medium" type="primary" @click="dialogFormVisible = true" icon="el-icon-plus"
                             class="el-btn">
                    {{ $t('deng-ji-ge-ren-zhuang') }}
                  </el-button>
                </el-col>
              </el-row>
              <!-- 编辑界面 -->
              <el-dialog :title="$t('deng-ji-ge-ren-zhuang-0')" :visible.sync="dialogFormVisible" :modal-append-to-body='false'>
                <el-form :model="form" style="height: 400px;overflow: auto">
                  <el-form-item :label="$t('zhuang-ti-ming-cheng')" :label-width="formLabelWidth">
                    <el-input autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('zhuang-ti-bian-hao')" :label-width="formLabelWidth">
                    <el-input autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('suo-shu-yong-hu')" :label-width="formLabelWidth">
                    <el-input autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('lian-xi-dian-hua-0')" :label-width="formLabelWidth">
                    <el-input autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('suo-zai-sheng-0')" :label-width="formLabelWidth">
                    <el-select :placeholder="$t('suo-zai-sheng-1')">
                      <el-option :label="$t('screen.beijing')" value="1"></el-option>
                      <el-option :label="$t('screen.shanghai')" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('suo-zai-shi-0')" :label-width="formLabelWidth">
                    <el-select :placeholder="$t('suo-zai-shi-1')">
                      <el-option :label="$t('screen.beijing')" value="1"></el-option>
                      <el-option :label="$t('screen.shanghai')" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('xian-qu-0')" :label-width="formLabelWidth">
                    <el-select :placeholder="$t('xian-qu-1')">
                      <el-option :label="$t('screen.beijing')" value="1"></el-option>
                      <el-option :label="$t('screen.shanghai')" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('chong-dian-zhuang-zhuang-tai')" :label-width="formLabelWidth">
                    <el-select :placeholder="$t('operatingViewOperator.selectPlaceholder')">
                      <el-option :label="$t('dui-wai-kai-fang')" value="1"></el-option>
                      <el-option :label="$t('zan-bu-dui-wai-kai-fang')" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('chuang-jian-shi-jian')" :label-width="formLabelWidth">
                    <el-date-picker v-model="val_time" type="datetime" :placeholder="$t('xuan-ze-ri-qi-shi-jian')">
                    </el-date-picker>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button size="small" @click="dialogFormVisible = false">{{ $t('qu-xiao') }}</el-button>
                  <el-button size="small" type="primary" @click="dialogFormVisible = false">{{ $t('que-ding') }}</el-button>
                </div>
              </el-dialog>
              <!--搜索框-->
              <el-row v-show="show3">
                <el-col :span="5">
                  <el-form-item>
                    <el-input :placeholder="$t('zhuang-ti-ming-cheng-0')" v-model="input" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item>
                    <el-input :placeholder="$t('suo-shu-yong-hu')" v-model="input" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5">
                  <el-form-item>
                    <el-input :placeholder="$t('zhuang-ti-bian-hao-0')" v-model="input" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row v-show="show3">
                <el-col :span="2" style="float: right">
                  <el-form-item>
                    <el-button size="small" class="el_clear" icon="el-icon-close">{{ $t('deviceControl.empty') }}</el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="1.5" style="float: right">
                  <el-form-item>
                    <el-button size="small" class="el_search" icon="el-icon-search">{{ $t('deviceControl.search') }}</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <!--列表数据-->
            <el-tab-pane :label="$t('ge-ren-zhuang-lie-biao')" name="stationList">
              <el-table :data="views" stripe style="width: 100%">
                <!--<af-table-column type="selection"></af-table-column>-->
                <af-table-column prop="" :label="$t('zhuang-ti-ming-cheng-1')"></af-table-column>
                <af-table-column prop="" :label="$t('zhuang-ti-bian-hao-1')"></af-table-column>
                <af-table-column prop="" :label="$t('suo-shu-yong-hu')"></af-table-column>
                <af-table-column prop="" :label="$t('yun-ying-zhuang-tai')"></af-table-column>
                <af-table-column prop="" :label="$t('chuang-jian-shi-jian')"></af-table-column>

                <af-table-column :label="$t('deviceControl.operation')">
                  <template slot-scope="scope">
                    <!--<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
                    <!--<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>-->
                  </template>
                </af-table-column>
              </el-table>
              <!--工具条-->
              <el-col :span="24" class="toolbar">
                <!--                <el-button align="left" type="danger">批量修改</el-button>-->
                <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
                               :total="total" style="float:right;">
                </el-pagination>
              </el-col>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
  export default {
    name: 'personPileManager',
    data() {
      return {
        activeName: 'stationList',
        show3: false,
        input: '',
        dialogFormVisible: false,
        val_time: '',
        formLabelWidth: '120px'
      }
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event)
      },
      handleEdit(index, row) {
        console.log(index, row)
      },
      handleDelete(index, row) {
        console.log(index, row)
      }
    }
  }
</script>

<style scoped lang="less">
  .el_search {
    background-color: teal;
    color: white;
  }

  .el_clear {
    background-color: darkorange;
    color: white;
  }

  .el-btn {
    /*float: right;*/
    margin-bottom: 15px;
  }

  /deep/ .search_form {
    .el-form-item__content {
      .el-input {
        width: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/personPileManager.vue